// todo - maybe rename to something more flexible to hold event width responsive values

import { ACTIONS, DEBUG_DATE, IS_TEST, MS_DAY } from '../../constants';

// -------------------------------------------------------
// Init state
// -------------------------------------------------------

const getInitDayId = () => {
  // set start date
  let actualDate = null;
  if (process.env.NODE_ENV !== 'production') {
    // local debug
    actualDate = DEBUG_DATE;
  } else if (
    window.fakeDate !== null &&
    typeof window.fakeDate !== 'undefined'
  ) {
    // test fake
    actualDate = new Date(window.fakeDate);
  } else {
    // normal - server date
    actualDate = new Date(window.date);
  }

  return Math.max(
    Math.floor(
      (actualDate - new Date('2018-01-01T00:00:00.000+01:00')) / MS_DAY
    ),
    0
  );
};

const getInitState = () => {
  const initDayId = getInitDayId();
  // const endDayId = Math.max(initDayId, 243); // added summer unlock check
  return {
    currentDayId: initDayId,
    startDayId: initDayId,
    endDayId: 365, // whole year unlock - Before state: IS_TEST ? 365 : Math.ceil((endDayId + 1) / 7) * 7 - 1, // last unlocked day (sunday in current week)
    columns: 0, // calculated by width
    detailActive: false,
    daySelectOpen: false
  };
};

// -------------------------------------------------------
// Parsing
// -------------------------------------------------------

const getStartDayId = (dayId, state) =>
  Math.min(dayId, state.endDayId - (state.columns - 1));

// -------------------------------------------------------
// Navigation
// -------------------------------------------------------

const navigation = (state = getInitState(), action) => {
  switch (action.type) {
    case ACTIONS.SET_START_DAY:
      return {
        ...state,
        startDayId: getStartDayId(action.startId, state),
        daySelectOpen: state.daySelectOpen
          ? !state.daySelectOpen
          : state.daySelectOpen
      };
    case ACTIONS.COLUMNS_UPDATE:
      return {
        ...state,
        startDayId: getStartDayId(state.currentDayId, state),
        columns: action.columns
      };
    case ACTIONS.DAY_SELECT_SWITCH:
      return {
        ...state,
        daySelectOpen: action.show
      };
    default:
      return state;
  }
};

export default navigation;



// WEBPACK FOOTER //
// ./src/redux/reducers/navigation.js